import { render, staticRenderFns } from "./VNavigationItem.vue?vue&type=template&id=cf1079f6&scoped=true&"
import script from "./VNavigationItem.vue?vue&type=script&lang=js&"
export * from "./VNavigationItem.vue?vue&type=script&lang=js&"
import style0 from "./VNavigationItem.vue?vue&type=style&index=0&id=cf1079f6&lang=scss&scoped=true&"
import style1 from "./VNavigationItem.vue?vue&type=style&index=1&id=cf1079f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1079f6",
  null
  
)

export default component.exports